var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4E3C3"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED8B2"
    },
    d: "M509.686,290.445L367.928,148.687l-6.708,7.225l-41.782-41.782l-74.426,34.732l-75.779,10.743 l-22.804,6.178l71.861,71.039l-58.035,70.396l-19.325,62.561l41.513,41.513l-32.546,15.376l84.409,84.409 c7.154,0.6,14.386,0.924,21.694,0.924C385.703,512,492.859,415.539,509.686,290.445z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.593,
    y: 170.667,
    style: {
      fill: "#324A5E"
    },
    width: 94.815,
    height: 77.576
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.431,
    y: 170.667,
    style: {
      fill: "#2B3B4E"
    },
    width: 47.981,
    height: 77.576
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD8469"
    },
    d: "M175.407,369.778h-28.444V244.076c0-9.125,7.397-16.52,16.522-16.52h11.923V369.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6F58"
    },
    d: "M336.593,369.778h28.444V244.076c0-9.125-7.397-16.52-16.52-16.52h-11.924V369.778z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.754,
    y: 152.135,
    style: {
      fill: "#324A5E"
    },
    width: 48.269,
    height: 8.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.889,
    y: 152.135,
    style: {
      fill: "#2B3B4E"
    },
    width: 48.269,
    height: 8.62
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M307.059,202.231H204.941c-9.885,0-17.898-8.013-17.898-17.898v-57.296 c0-9.885,8.013-17.898,17.898-17.898h102.117c9.885,0,17.898,8.013,17.898,17.898v57.296 C324.956,194.217,316.944,202.231,307.059,202.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1321F"
    },
    d: "M307.059,109.14h-51.633v93.091h51.633c9.885,0,17.898-8.013,17.898-17.898v-57.296 C324.956,117.153,316.944,109.14,307.059,109.14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.458,
    y: 312.889,
    style: {
      fill: "#FD8469"
    },
    width: 50.772,
    height: 113.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.773,
    y: 312.889,
    style: {
      fill: "#FC6F58"
    },
    width: 50.772,
    height: 113.778
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B9ED8"
    },
    d: "M317.802,346.259H194.198c-12.997,0-23.531-10.535-23.531-23.531v-82.968 c0-12.997,10.535-23.531,23.531-23.531h123.604c12.997,0,23.531,10.535,23.531,23.531v82.968 C341.333,335.724,330.799,346.259,317.802,346.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D8CB7"
    },
    d: "M317.802,216.228h-62.376V346.26h62.376c12.997,0,23.531-10.535,23.531-23.531v-82.968 C341.333,226.763,330.799,216.228,317.802,216.228z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#31BAFD"
    },
    cx: 156.444,
    cy: 155.686,
    r: 14.222
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B54C"
    },
    cx: 221.522,
    cy: 281.238,
    r: 28.444
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B5F1F4"
    },
    cx: 213.333,
    cy: 156.444,
    r: 14.222
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 213.333,
    cy: 156.444,
    r: 7.758
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B5F1F4"
    },
    cx: 298.667,
    cy: 156.444,
    r: 14.222
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#31BAFD"
    },
    cx: 355.556,
    cy: 155.686,
    r: 14.222
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.67,
    y: 242.45,
    style: {
      fill: "#E6F3FF"
    },
    width: 49.993,
    height: 77.576
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.897,
    y: 398.222,
    style: {
      fill: "#324A5E"
    },
    width: 85.333,
    height: 28.444
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.773,
    y: 398.222,
    style: {
      fill: "#2B3B4E"
    },
    width: 85.333,
    height: 28.444
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.593,
    y: 341.333,
    style: {
      fill: "#F1543F"
    },
    width: 34.478,
    height: 28.444
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.929,
    y: 341.333,
    style: {
      fill: "#FC6F58"
    },
    width: 34.478,
    height: 28.444
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M256,178.424c-8.08,0-14.653-6.573-14.653-14.653h5.172c0,5.227,4.255,9.481,9.481,9.481 c5.227,0,9.481-4.255,9.481-9.481h5.172C270.653,171.851,264.08,178.424,256,178.424z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M265.481,163.771c0,5.227-4.255,9.481-9.481,9.481c-0.193,0-0.383-0.017-0.574-0.029v5.172 c0.191,0.007,0.381,0.029,0.574,0.029c8.08,0,14.653-6.573,14.653-14.653H265.481z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B3B4E"
    },
    cx: 298.667,
    cy: 156.444,
    r: 7.758
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.9bed5b681cf10a53fad202e263e85e19.svg";
export { ForwardRef as ReactComponent };